import React from 'react';
import PropTypes from 'prop-types';

export default class OutsourceBadge extends React.Component {

  getBadgeClassLevel(level){
    switch (level){
      case 1:
        return 'bg-orange';
      case 2:
        return 'bg-grey';
      case 3:
        return 'bg-brown';
      default:
        return '';
    }
  }

  render() {
    if (!this.props.level){
      return null;
    }
    const badgeClassName = 'label ' + this.getBadgeClassLevel(this.props.level);
    return (
      <span className={badgeClassName}>{this.props.level}</span>
    );
  }

}


OutsourceBadge.propTypes = {
  level: PropTypes.number.isRequired
};

OutsourceBadge.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/OutsourceBadge.js